module.exports = __webpack_public_path__ + "static/img/company-info.60db37c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/abouts/company-info.jpg
// module id = tf3q
// module chunks = 1